import ContactPage from "../../../../pages/ContactPage/ContactPage";
import InformationPage from "../../../../pages/InformationPage/InformationPage";
import MainPage from "../../../../pages/MainPage/MainPage";
import WorksPage from "../../../../pages/WorksPage/WorksPage";
import { cameraIcon } from "../../../../shared/assets/svg/cameraIcon";
import { contactIcon } from "../../../../shared/assets/svg/contactIcon";
import { flowerIcon } from "../../../../shared/assets/svg/flowerIcon";
import { homeIcon } from "../../../../shared/assets/svg/homeIcon";

import { getRouteContact, getRouteInformation, getRouteMain, getRouteMyWorks } from "./helpers";

const routeConfige = {
    main: {
        path: getRouteMain(),
        element: <MainPage/>,
        navlink: 'главная',
        img: homeIcon(),
    },
    works: {
        path: getRouteMyWorks(),
        element: <WorksPage/>,
        navlink: 'мои работы',
        img: cameraIcon(),
    },
    information: {
        path: getRouteInformation(),
        element: <InformationPage/>,
        navlink: 'обо мне',
        img: flowerIcon(),
    },
    contact: {
        path: getRouteContact(),
        element: <ContactPage/>,
        navlink: 'контакты',
        img: contactIcon(),
    },
 
}

export default routeConfige;